import { RestrictMallCode } from '@/enum/localEnum'

export default async function ({ store, redirect }) {
    const userInfo = store.state.user.userinfo
    const { restrictMall = [] } = userInfo
    // 在服务端和客户端都执行权限检查
    try {
        // 如果服务端没有数据，尝试获取
        if (process.server && restrictMall.length === 0) {
            await store.dispatch('user/UserRestrictMall')
        }

        const isRestrict = store.getters['user/checkUserRestrictMall'](RestrictMallCode.AGENCY_BUY)

        if (isRestrict) {
            redirect('/')
        }
    } catch {
        redirect('/')
    }
}
